@import '~style-sheet-helpers/core.less';

.main-content {
  overflow: hidden;
}

.alerts-page-wrappers {
  height: 100%;
  width: 200%;
  display: flex;
  transform: translateX(0);
  transition: all 300ms ease;

  &.detail-page-in {
    transform: translateX(-50%);
  }
}

.list-page {
  width: 50%;
}

.detail-page {
  width: 50%;
}
